import { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import apiClient from "../Helpers/apiClient";
import AuthContext from "../Helpers/auth-context";
import Button from "@mui/material/Button";

function QuoteProductForm() {
    const [quoteId, setQuoteId] = useState(null);
    const [productName, setProductName] = useState("");
    const [partNumber, setPartNumber] = useState("");
    const [detailDescriptions, setDetailDescriptions] = useState("");
    const [quantity, setQuantity] = useState(1);
    const [price, setPrice] = useState(0);
    const [loading, setLoading] = useState(true);

    const location = useLocation();
    const navigate = useNavigate();
    const { state, dispatch } = useContext(AuthContext);

    // Extract and preserve URL parameters
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const id = params.get("id");

        if (id) {
            setQuoteId(id);
        }

        // Check authentication after getting URL params
        checkAuth();
    }, [location]);

    // Authentication check function
    const checkAuth = () => {
        if (!state.isAuthenticated) {
            // Preserve the ENTIRE current URL (including params) in the state
            navigate("/login", {
                state: {
                    returnTo: location.pathname + location.search,
                },
            });
        } else {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!quoteId) {
            alert("Quote ID is required");
            return;
        }
        if (!productName) {
            alert("Product Name is required for write-in products");
            return;
        }

        try {
            const payload = {
                quoteId,
                productName,
                partNumber,
                pcs_DetailDescriptions: detailDescriptions,
                quantity,
                price,
            };
            const response = await apiClient.post(
                "/api/dataverse/create",
                payload
            );
            alert(response.data.message);
        } catch (error) {
            console.error("Error creating quote product:", error);
            alert("Failed to create quote product");
        }
    };

    // Show loading state while checking authentication
    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div>
            {quoteId ? (
                <div>
                    <h1>Add Write-In Product to Quote ID: {quoteId}</h1>
                    <form onSubmit={handleSubmit}>
                        <div>
                            <label>Product Name:</label>
                            <input
                                type="text"
                                value={productName}
                                onChange={(e) => setProductName(e.target.value)}
                                placeholder="Enter write-in product name"
                                required
                            />
                        </div>
                        <div>
                            <label>Part Number:</label>
                            <input
                                type="text"
                                value={partNumber}
                                onChange={(e) => setPartNumber(e.target.value)}
                                placeholder="Enter part number"
                            />
                        </div>
                        <div>
                            <label>
                                Detail Descriptions (pcs_DetailDescriptions):
                            </label>
                            <textarea
                                value={detailDescriptions}
                                onChange={(e) =>
                                    setDetailDescriptions(e.target.value)
                                }
                                placeholder="Enter detail descriptions"
                                rows={4}
                                cols={50}
                                style={{
                                    width: "100%",
                                    padding: "8px",
                                    borderRadius: "4px",
                                    border: "1px solid #ccc",
                                    fontFamily: "inherit",
                                    resize: "vertical",
                                }}
                            ></textarea>
                        </div>
                        <div>
                            <label>Quantity:</label>
                            <input
                                type="number"
                                value={quantity}
                                onChange={(e) =>
                                    setQuantity(Number(e.target.value))
                                }
                                min="1"
                                required
                            />
                        </div>
                        <div>
                            <label>Price per Unit:</label>
                            <input
                                type="number"
                                value={price}
                                onChange={(e) =>
                                    setPrice(Number(e.target.value))
                                }
                                min="0"
                                step="0.01"
                                required
                            />
                        </div>
                        <button type="submit">Add Write-In Product</button>
                    </form>

                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: "#58627b",
                            color: "#fff",
                            padding: "5px",
                        }}
                        onClick={() => {
                            // Clear localStorage and handle logout logic
                            localStorage.removeItem("authState");

                            setTimeout(() => {
                                dispatch({ type: "LOGOUT" }); // Trigger logout action
                                //  navigate("/"); // Redirect to home after 2 seconds
                                window.location.reload(); // Refresh the page after 2 seconds
                            }, 2000);
                        }}
                    >
                        Log out
                    </Button>
                </div>
            ) : (
                <p>No Quote ID provided</p>
            )}
        </div>
    );
}

export default QuoteProductForm;
